import { render, staticRenderFns } from "./StarTemplate.vue?vue&type=template&id=ab2aee0a&scoped=true&"
import script from "./StarTemplate.vue?vue&type=script&lang=js&"
export * from "./StarTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StarTemplate.vue?vue&type=style&index=0&id=ab2aee0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2aee0a",
  null
  
)

export default component.exports